module.exports = __webpack_public_path__ + "img/arrow-annual-blue.e5e52461.svg";